/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_FilesInputs */

const en_media_files = /** @type {(inputs: Media_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media Files`)
};

const fr_media_files = /** @type {(inputs: Media_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fichiers multimédia`)
};

const de_media_files = /** @type {(inputs: Media_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mediendateien`)
};

const it_media_files = /** @type {(inputs: Media_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File multimediali`)
};

const ru_media_files = /** @type {(inputs: Media_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Медиафайлы`)
};

const es_media_files = /** @type {(inputs: Media_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivos multimedia`)
};

const zh_cn2_media_files = /** @type {(inputs: Media_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`媒体文件`)
};

const ja_media_files = /** @type {(inputs: Media_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メディアファイル`)
};

const hi_media_files = /** @type {(inputs: Media_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मीडिया फ़ाइलें`)
};

const pt_pt2_media_files = /** @type {(inputs: Media_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquivos de mídia`)
};

/**
* | output |
* | --- |
* | "Media Files" |
*
* @param {Media_FilesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_files = /** @type {((inputs?: Media_FilesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_FilesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_media_files(inputs)
	if (locale === "de") return de_media_files(inputs)
	if (locale === "it") return it_media_files(inputs)
	if (locale === "ru") return ru_media_files(inputs)
	if (locale === "es") return es_media_files(inputs)
	if (locale === "zh-CN") return zh_cn2_media_files(inputs)
	if (locale === "ja") return ja_media_files(inputs)
	if (locale === "hi") return hi_media_files(inputs)
	if (locale === "pt-PT") return pt_pt2_media_files(inputs)
	return en_media_files(inputs)
});